import styled from 'styled-components';

import { Description } from './description';
import { ISanityHeroTextProps } from './types';
import { getColorForSanityHeroTextColor } from './utils';

export const SanityDescription = styled(Description)<ISanityHeroTextProps>`
  color: ${({ sanityTextColor, defaultTextColor }) =>
    getColorForSanityHeroTextColor(sanityTextColor, defaultTextColor)};
`;
